module.exports = __webpack_public_path__ + "static/media/restricted.a5867732.png";